import React from 'react'
import About from "../Components/About/About";

const PageTwo = () => {
  return (
    <div>
        <About />
    </div>
  )
}

export default PageTwo